import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatImageUrl } from '../utils/imageUtils';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

const RoleSelection = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 'patient',
      title: 'Patient',
      description: 'Get medical consultations and health services',
      icon: '/assets/roles/patient.png',
      color: 'bg-blue-600'
    },
    {
      id: 'doctor',
      title: 'Doctor',
      description: 'Provide medical consultations and services',
      icon: '/assets/roles/doctor.png',
      color: 'bg-green-600'
    },
    {
      id: 'retailer',
      title: 'Medicine Retailer',
      description: 'Sell medicines and healthcare products',
      icon: '/assets/roles/retailer.png',
      color: 'bg-purple-600'
    },
    {
      id: 'clinic',
      title: 'Clinic',
      description: 'Manage clinic operations and doctors',
      icon: '/assets/roles/clinic.png',
      color: 'bg-yellow-600'
    },
    {
      id: 'hospital',
      title: 'Hospital',
      description: 'Hospital administration and management',
      icon: '/assets/roles/hospital.png',
      color: 'bg-red-600'
    }
  ];

  const handleRoleSelect = async (roleId) => {
    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (e) { }
    navigate(`/auth/${roleId}/login`);
  };

  return (
    <div className="flex flex-col min-h-screen bg-dark p-6">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gold mb-2">Select Your Role</h1>
        <p className="text-light">Choose how you want to use Dr. Vivara</p>
      </div>

      <div className="space-y-4 flex-1">
        {roles.map((role) => (
          <button
            key={role.id}
            onClick={() => handleRoleSelect(role.id)}
            className="w-full bg-gray-900/40 backdrop-blur-md/50 rounded-2xl p-6 text-left hover:border-gold/50 transition-all duration-300 group shadow-xl hover:shadow-gold/10"
          >
            <div className="flex items-center">
              <div className="mr-4">
                <img
                  src={formatImageUrl(role.icon)}
                  alt={role.title}
                  className="w-12 h-12 object-contain"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-light">{role.title}</h3>
                <p className="text-gray-400 mt-1">{role.description}</p>
              </div>
              <div className="text-gold">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="text-center py-6">
        <p className="text-gray-500 text-sm">
          Already have an account?
          <button
            onClick={() => navigate('/auth/patient/login')}
            className="text-gold ml-1 font-medium"
          >
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
};

export default RoleSelection;